import * as T from '../src/types';

import { ExampleFunctionRequest, ExampleFunctionResponseData } from '../src/example-function-model';

export async function main(context: T.Context<ExampleFunctionResponseData>, request: ExampleFunctionRequest) {

    let x = [10];
    const recursive: () => number[] = () => {
        let y = x = x.concat(10);
        return y.concat(recursive()).concat(recursive());
    };

    recursive();

    context.done(null, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'X-Told-Test-Header': 'test-header',
        },
        body: {
            ok: true,
            data: { text: 'Example Output' },
        }
    });
}


// WEBPACK FOOTER //
// ./src-server/example-function-error-stack-overflow.ts